import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import de from '@/locales/de.json'
import es from '@/locales/es.json'
import fr from '@/locales/fr.json'
import it from '@/locales/it.json'
import pt from '@/locales/pt.json'
import cs from '@/locales/cs.json'

export type AppLocale = 'de' | 'en' | 'fr' | 'es' | 'it' | 'pt' | 'cs'

export const SUPPORTED_LOCALES: { value: AppLocale; labelKey: string }[] = [
  { value: 'de', labelKey: 'settings.languageDe' },
  { value: 'en', labelKey: 'settings.languageEn' },
  { value: 'fr', labelKey: 'settings.languageFr' },
  { value: 'es', labelKey: 'settings.languageEs' },
  { value: 'it', labelKey: 'settings.languageIt' },
  { value: 'pt', labelKey: 'settings.languagePt' },
  { value: 'cs', labelKey: 'settings.languageCs' },
]

export const i18n = createI18n({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'en',
  messages: { en, de, es, fr, it, pt, cs },
  globalInjection: true,
})

const APP_LOCALE_SET = new Set<AppLocale>(['de', 'en', 'fr', 'es', 'it', 'pt', 'cs'])

export function normalizeAppLocale(value: string | null | undefined): AppLocale | null {
  const base = String(value || '').trim().toLowerCase().replace(/_/g, '-').split('-')[0]
  const normalized = base === 'cz' ? 'cs' : base
  return APP_LOCALE_SET.has(normalized as AppLocale) ? normalized as AppLocale : null
}

export function isAppLocale(value: string | null | undefined): value is AppLocale {
  return value != null && APP_LOCALE_SET.has(value as AppLocale)
}
